// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"cf31cafa1a82753acae9","873":"a873dddf510424725ce0"}[chunkId] + ".js";
};